module.exports = __webpack_public_path__ + "img/album23_05.27cab0df.jpg";